import { makeStyles } from '@mui/styles';
const circleLoaderStyles = makeStyles(({ palette }) => ({
    message: {
        marginTop: '20px',
        color: palette.primary.main,
        fontSize: 'inherit',
        fontWeight: 500,
    },
    fancyLoader: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
    },
    spinner: {
        width: '60px',
        height: '60px',
        border: `6px solid ${palette.grey[100]}`,
        borderTop: `6px solid ${palette.primary.main}`,
        borderRadius: '50%',
        animation: '$spin 1s linear infinite',
    },
    '@keyframes spin': {
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(360deg)',
        },
    },
    loader: {
        color: palette.primary.main,
    },
}));
export default circleLoaderStyles;
//# sourceMappingURL=circleLoader.styles.js.map